import { Navigate } from 'react-router-dom';
import { useTenant } from '../components/TenantContext.jsx';

/**
 * 超級管理帳號 (accountRole=super_admin) 專屬 route 守衛。
 * 經銷商/商用/子帳號 deep-link /admin/* 一律導回首頁。
 * nav 隱藏只是 UX；這層 + server 端 gate（/me accountRole、builder blockNonSuperAdminOps、
 * backend saasAdmin resolveCaller）才是真正的權限邊界。
 */
export function RequireSuperAdmin({ children }) {
    const { isSuperAdmin, loading } = useTenant();
    if (loading) {
        return (
            <div className="grid min-h-dvh place-items-center text-ink-500">
                <div className="font-mono text-sm">Loading…</div>
            </div>
        );
    }
    if (!isSuperAdmin) return <Navigate to="/" replace />;
    return children;
}
